import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Alert, Card, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { Ctx } from 'components/CtxFormFields/CtxInputs';
import useErrorState, { translateError } from 'utils/hooks/useErrorState';
import RenderFormItem from 'components/CtxFormFields/FormFieldCtx';

import { pceftposFields, pceftposDefaults } from './formShape';

function PCEftpos() {
  const { level } = useParams();
  const formContext = useContext(Ctx);
  const { loading, integrationState, setEnabledSave, initialIntegrationState } =
    formContext.values;
  const values = useMemo(
    () => ({ ...pceftposDefaults, ...integrationState }),
    [pceftposDefaults, integrationState],
  );
  const { errors, hasErrors } = useErrorState(values, pceftposFields);

  const [enableWarning, setEnableWarning] = useState(false);

  const onChange = (key, value) => {
    formContext.onChange({ [key]: value });
  };

  // Track for changes in tcpipDevicePort and activate the Alert to the user
  useEffect(() => {
    // if user changed the values of tcpipDevicePort
    // and the new value is not empty string enable Alert
    const shouldAlert =
      initialIntegrationState?.tcpipDevicePort !==
        integrationState?.tcpipDevicePort &&
      !!integrationState?.tcpipDevicePort;

    setEnableWarning(shouldAlert);
  });

  useEffect(() => {
    setEnabledSave(!hasErrors);
  }, [errors]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="d-flex flex-column flex-fill">
      <Alert variant="warning">
        For the current moment, PC-Eftpos micro-service only works on Windows
        operating system.
      </Alert>
      <Ctx.Provider
        value={useMemo(() => ({ values, onChange }), [values, onChange])}
      >
        {level === 'Pos' ? (
          <Card className="my-3">
            <Card.Header>PC-Eftpos Credentials</Card.Header>
            <Card.Body>
              <Form>
                {Object.values(pceftposFields).map(({ validate, ...rest }) => (
                  <RenderFormItem
                    key={rest.id}
                    size="md"
                    name={rest.id}
                    error={translateError(errors[rest.id], null)}
                    {...rest}
                  />
                ))}
              </Form>
              {enableWarning && (
                <Alert variant="warning">
                  NB! Please, restart computer after updating PC-Eftpos Client
                  Port!
                </Alert>
              )}
            </Card.Body>
          </Card>
        ) : (
          <Alert variant="warning">
            PC-Eftpos needs PORT, IP and Device PORT to be configured. These are
            specific for each POS. Go to Pos Level to finish the configuration.
          </Alert>
        )}

        <Card className=" mt-3 ">
          <Card.Header>
            Follow the few steps below to download and install PC-Eftpos device
            integration on your machine
          </Card.Header>
          <Card.Body>
            <ol>
              <li>
                Download the latest PC-Eftpos release{' '}
                <a href="https://pceftpos.com/downloads/">here</a>.
              </li>
              <li>
                Execute the downloaded file by double clicking on it. Your{' '}
                <em>Windows</em> software assistant will help you with the
                installation further on.
              </li>
            </ol>
          </Card.Body>
        </Card>
      </Ctx.Provider>
    </div>
  );
}

export default PCEftpos;
